<template>
  <div class="d-flex flex-column justify-content-end w-100">
    <label
      v-if="itemModel.vars.label"
      :class="
        'form-label' +
        (itemModel.vars.label_attr && itemModel.vars.label_attr.class ? ' ' + itemModel.vars.label_attr.class : '') +
        (itemModel.vars.required ? ' required' : '')
      "
    >
      {{ index ? index + ". " : "" }}{{ itemModel.vars.label }}{{ itemModel.vars.required ? "*" : "" }}
      <span
        v-if="itemModel.vars.help && !isMobile()"
        class="form-info"
        v-tooltip="{ title: itemModel.vars.help, textWrap: true }"
      >
        <FontAwesomeIcon icon="fa-light fa-circle-question" />
      </span>
    </label>
    <div v-if="isMobile() && itemModel.vars.help" class="form-info">
      <FontAwesomeIcon icon="fa-light fa-circle-question" />
      {{ itemModel.vars.help }}
    </div>
    <textarea
      :id="itemModel.vars.id"
      v-model="itemModel.vars.value"
      :class="computedClass"
      :disabled="forcedDisabled || itemModel.vars.disabled === true"
      :name="language ? itemModel.vars.name + '-' + language : itemModel.vars.name"
      :placeholder="itemModel.vars.attr && itemModel.vars.attr.placeholder ? itemModel.vars.attr.placeholder : ''"
      style=""
      :required="itemModel.vars.required === true"
      :aria-invalid="itemModel.vars.error ? 'true' : 'false'"
      :aria-describedby="itemModel.vars.error ? itemModel.vars.id + '-error' : null"
      @blur="blur"
      @change="change"
      @focus="focus"
      @input="input"
    ></textarea>
    <div v-if="itemModel.vars.error" :id="itemModel.vars.id + '-error'" class="invalid-feedback d-block" role="alert">
      {{ itemModel.vars.error }}
    </div>
    <WritingAssistantComponent
      ref="assistant"
      v-if="itemModel.vars.attr && itemModel.vars.attr[aiAssistantDataAttr]"
      :inputValue="itemModel.vars.value"
      :fieldData="itemModel.vars.attr[aiAssistantDataAttr]"
      :isDisabled="itemModel.vars.aiAssistantDisabled === true"
      @disabled="disableAssistant"
    />
  </div>
</template>

<script>
import { formValidator } from "@/services/form/form-validator";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import WritingAssistantComponent from "@/components/form/WritingAssistantComponent.vue";
import { writingAssistantConstantes } from "@/constantes/writingAssistant";

export default {
  name: "TextareaTypeComponent",
  components: { FontAwesomeIcon, WritingAssistantComponent },
  props: {
    model: {
      type: Object,
      required: true,
    },
    language: {
      type: String,
      required: false,
      default: "fr",
    },
    index: {
      type: [Number, null],
      required: false,
      default: null,
    },
    forcedDisabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  emits: ["draft", "focus", "update", "save"],
  data() {
    return {
      itemModel: this.model,
    };
  },
  computed: {
    aiAssistantDataAttr() {
      return writingAssistantConstantes.AI_ASSISTANT_DATA_ATTR;
    },
    computedClass() {
      const attrClass =
        this.itemModel.vars.attr && this.itemModel.vars.attr.class ? " " + this.itemModel.vars.attr.class : "";
      if (this.itemModel.vars.error || this.itemModel.vars.isInvalid) {
        return "form-control is-invalid" + attrClass;
      } else if (!this.itemModel.vars.error && this.itemModel.vars.required) {
        return "form-control is-valid" + attrClass;
      }
      return "form-control" + attrClass;
    },
  },
  watch: {
    model(newVal) {
      this.itemModel = newVal;
    },
  },
  methods: {
    blur() {
      this.valid(true);
      this.$emit("update", this.itemModel.vars.value, this.index);
    },
    input() {
      this.$refs.assistant?.onUserInput();
      this.valid();
      this.$emit("update", this.itemModel.vars.value, this.index);
      this.$emit("draft", this.itemModel);
    },
    change() {
      this.valid();
      this.$emit("draft", this.itemModel);
      this.$emit("update", this.itemModel.vars.value, this.index);
    },
    focus() {
      this.$emit("focus");
    },
    valid(blur = false) {
      if (blur) {
        this.$emit("save");
      }
      if (this.itemModel.vars.required) {
        formValidator.validModel(this.itemModel, this.language);
      }
    },
    isMobile() {
      return window.innerWidth < 992;
    },
    disableAssistant() {
      this.itemModel.vars.aiAssistantDisabled = true;
    },
    getClass() {
      const errors = formValidator.validModel(this.itemModel);
      if (this.itemModel.vars.error || errors.length) {
        this.itemClass = "form-control is-invalid";
      } else if (!errors.length && !this.itemModel.vars.error && this.itemModel.vars.required) {
        this.itemClass = "form-control is-valid";
      } else {
        this.itemClass = "form-control";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
textarea {
  min-height: 100px;
}
</style>
